/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import {
  Card,
  Layout,
  Button,
  TextContainer,
  Caption,
  TextStyle,
  Icon,
  Tooltip
} from '@shopify/polaris';
import { connect } from 'react-redux';
import { QuestionMarkMajor, CircleTickMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import * as syncActions from 'actions/sync-actions';
import { site } from 'src/config/';
// import { syncStep } from 'src/constants/sync';
import { formatDatetime } from 'src/helpers';
import sync from 'src/assets/images/dashboard/sync.png';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  manualSyncLoading: boolean,
  error: any,
  syncLoading: boolean,
  lastSyncedDoneAt: number,
  tenantId: string,
  getSyncStatus: (tenantId: string) => void,
  resetSyncStatus: () => void
};

type ComposedProps = Props & WithI18nProps;
// NOT DONE TRANSLATION - WONT BE ABLE TO TEST - UPCOMING UPDATES BTW
class SyncHookStatus extends Component<ComposedProps> {
  timeoutGetSyncStatus = undefined;

  componentDidMount() {
    const { getSyncStatus, tenantId } = this.props;
    getSyncStatus(tenantId);
  }

  componentWillReceiveProps(nextProps: Props) {
    const { syncLoading } = nextProps;
    const { syncLoading: syncLoadingPrev } = this.props;
    if (syncLoadingPrev && !syncLoading) {
      const { getSyncStatus, tenantId } = this.props;

      // Set time out to get sync status --- Always runs
      this.timeoutGetSyncStatus = setTimeout(() => {
        getSyncStatus(tenantId);
      }, site.syncStatusTimeout);
    }
  }

  componentWillUnmount() {
    const { resetSyncStatus } = this.props;
    clearTimeout(this.timeoutGetSyncStatus);

    resetSyncStatus();
  }

  render() {
    let { lastSyncedDoneAt, i18n } = this.props;

    // get last update time
    lastSyncedDoneAt =
      lastSyncedDoneAt.length > 10 ? parseInt(lastSyncedDoneAt) : parseInt(lastSyncedDoneAt) * 1000;
    const lastUpdateTimeString = formatDatetime(lastSyncedDoneAt);

    return (
      <div className="BC-SyncHookStatus__Dashboard">
        <Card
          title={
            <div>
              <span className="Polaris-Heading">
                {i18n.translate('AdminHTML.Dashboard.SyncHookStatus.cardTitle_Span')}
              </span>
              <span className="tooltip">
                <Tooltip
                  content={
                    <span className="tooltipContent">
                      {i18n.translate(
                        'AdminHTML.Dashboard.SyncHookStatus.cardTitle_TooltipContent'
                      )}
                    </span>
                  }
                  preferredPosition="above"
                  children={<span>{i18n.translate('AdminHTML.Dashboard.Common.text')}</span>}>
                  <Icon source={QuestionMarkMajor} color="base" />
                </Tooltip>
              </span>
            </div>
          }>
          <Card.Section>
            <Layout>
              <Layout.Section>
                <TextContainer>
                  <React.Fragment>
                    <p>{i18n.translate('AdminHTML.Dashboard.SyncHookStatus.paragraph')}</p>
                    <div>
                      <Button primary onClick={this.goToSyncPage}>
                        {i18n.translate('AdminHTML.Dashboard.SyncHookStatus.buttonText')}
                      </Button>
                      {lastUpdateTimeString !== '' && (
                        <div className="recent-sync">
                          <span className="completed-icon">
                            <Icon source={CircleTickMajor} color="success" />
                          </span>
                          <Caption>
                            {i18n.translate('AdminHTML.Dashboard.SyncHookStatus.caption1')}{' '}
                            <TextStyle variation="strong">{lastUpdateTimeString}</TextStyle>
                          </Caption>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                </TextContainer>
              </Layout.Section>
              <Layout.Section secondary>
                <div className="BC-Illustration-Image__Dashboard">
                  <img
                    src={sync}
                    alt={i18n.translate('AdminHTML.Dashboard.SyncHookStatus.imgAlt')}
                  />
                </div>
              </Layout.Section>
            </Layout>
          </Card.Section>
        </Card>
      </div>
    );
  }

  goToSyncPage = () => {
    history.push(routes.sync.view());
  };
}

const mapStateToProps = (state, props) => {
  return {
    tenantId: _.get(state.oauth.tenantApp, 'tenantId', ''),
    error: _.get(state.sync, 'error', undefined),
    syncLoading: _.get(state.sync, 'syncLoading', false),
    lastSyncedDoneAt: _.get(state.sync, 'lastSyncedDoneAt', '0')
  };
};

const mapDispatchToProps = dispatch => ({
  // Get sync status
  getSyncStatus: tenantId => dispatch(syncActions.getSyncStatus(tenantId)),

  resetSyncStatus: () => dispatch(syncActions.resetSyncStatus())
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(SyncHookStatus));
